import React, { useContext } from 'react';
import PropTypes, { shape, string } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { params, string as stringType, shape as shapeType, bool as boolType } from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { getStoreTemplate } from '../helpers/store-helper';
import { dataModel } from '../../components/dataModel';
import './fulfillment-pod-store.scss';

export const FulfillmentPodStore = (props) => {
  const { itemId, onCheckNearbyStoresClick, storeId } = props;
  const { storeId: defaultStoreId, storeName, storeZip } = useStore();

  const { data, loading, error } = useProductDeprecated({
    itemId,
    storeId: storeId || defaultStoreId,
    domains: [
      'details',
      'media',
      'identifiers',
      'availabilityType',
      'fulfillment',
      'pricing',
      'reviews'
    ]
  });

  if (loading || !data?.product) {
    return null;
  }

  const product = data.product;

  // @TODO: How to handle not localized?
  // if (localizationStatus === 'default' || !stores) {
  //   return <NotLocalized />;
  // }

  const StoreComponent = getStoreTemplate({
    product,
    storeId: storeId || defaultStoreId,
    onCheckNearbyStoresClick
  }); //eslint-disable-line

  return (
    <StoreComponent
      product={product}
      onCheckNearbyStoresClick={onCheckNearbyStoresClick}
    />
  );
};

FulfillmentPodStore.propTypes = {
  itemId: string.isRequired,
  storeId: string,
  onCheckNearbyStoresClick: PropTypes.func
};

FulfillmentPodStore.defaultProps = {
  storeId: null,
  onCheckNearbyStoresClick: null
};

FulfillmentPodStore.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    info: shapeType({
      isLiveGoodsProduct: boolType()
    }),
    fulfillment: dataModel.clientOnlyProduct.fulfillment
  })
};
